import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function authServiceReducer(state = initialState.userdetails, action) {
    switch (action.type) {
        case types.USER_AUTH_SUCCESSFULL: return {
            ...state,
            loggedIn: true,
            token: action.token,
            user_type: action.user_type,
            invalid_user: false,
            password_used_in_history:false,
            TenantUserContext: null,
            password_expired:false,
            user_forbidden:false,
            singleSignOn_login_url:null,
            API_not_responding:false,
            EULA: false,
            userdetails:null,
            user_preferencedetails: "",
            workorder_user_preferencedetails: action.workorder_user_preferencedetails,
            preventative_maintenance_user_preferencedetails: action.preventative_maintenance_user_preferencedetails,
            error_response: action.error_response,
        };
        
        case types.USER_AUTH_UNSUCCESSFULL: return {
            ...state,            
            error_response: action.error_response,
            invalid_user:true,
            loggedIn: false,
            token: null,
            user_type: null,
            password_used_in_history:false,
            //invalid_user: false,
            TenantUserContext: null,
            password_expired:false,
            user_forbidden:false,
            singleSignOn_login_url:null,
            API_not_responding:false,
            EULA: false,
            userdetails:null,
            userTransaction:0
        };
        case types.PASSWORD_EXPIRED: return {
            ...state,
              loggedIn: false,
              token: null,
              user_type: null,
              invalid_user: false,
              user_details_complete_data:null,
              TenantUserContext: null,
              password_expired:true,
              password_used_in_history:false,
              user_forbidden:false,
              singleSignOn_login_url:null,
              API_not_responding:false,
              EULA: false,
              userdetails:null,
              userTransaction:0
          };

        case types.API_NOT_RESPONDING: return {
            ...state,
            loggedIn: false,
            // token: null,
            user_type: null,
            invalid_user: false,
            user_details_complete_data:null,
            TenantUserContext: null,
            password_expired:false,
            password_used_in_history:false,
            user_forbidden:false,
            singleSignOn_login_url:null,
            API_not_responding:true,
            EULA: false,
            userdetails:null
        };
        case types.USER_FORBIDDEN: return {
            ...state,
            loggedIn: false,
            token: null,
            user_type: null,
            invalid_user: false,
            TenantUserContext: null,
            password_expired:false,
            password_used_in_history:false,
            user_forbidden:true,
            singleSignOn_login_url:null,
            API_not_responding:false,
            EULA: false
        };
        case types.EULA_NOT_ACCEPTED: return {
            ...state,
            loggedIn: false,
            token: null,
            user_type: null,
            invalid_user: false,
            TenantUserContext: null,
            password_expired:false,
            password_used_in_history:false,
            user_forbidden:false,
            singleSignOn_login_url:null,
            API_not_responding:false,
            EULA: true,
            userdetails: action.getResponse
        };
        case types.PASSWORD_USED_IN_HISTORY_ERROR: return {
            ...state,
            loggedIn: false,
            token: null,
            user_type: null,
            invalid_user: false,
            TenantUserContext: null,
            password_expired:false,
            password_used_in_history:true,
            user_forbidden:false,
            singleSignOn_login_url:null,
            API_not_responding:false,
            EULA: false,
            userdetails:null
        };
          case types.SINGLE_SIGN_ON_FAILED: return {
            ...state,
            loggedIn: false,
            singleSignOn_login_url:action.getResponse
        };
        case types.GET_EMPLOYEE_LIST_SUCCESSFULL: return {
            ...state,
            TenantUserContext: action.getResponse,
        };
        case types.POST_USER_LOG_TRANSACTION_SUCCESSFULL: return {
            ...state,
            userTransaction: action.getResponse, 
        };
        case types.SET_ONPREMISE_DETAIL: return{
            ...state,
            IsOnPremise: action.getResponse, 
        };
        case types.SET_EQUIPMENT_SUMMARY_DETAIL: return{
            ...state,
            EquipmentSummaryDetail: action.getResponse,
        }
        case types.LOGOUT_USER:return {
            ...state,
        
            loggedIn: false,
            token: null,
            user_type: null,
            password_used_in_history:false,
            invalid_user: false,
            TenantUserContext: null,
            password_expired:false,
            user_forbidden:false,
            singleSignOn_login_url:null,
            API_not_responding:false,
            EULA: false,
            userdetails:null,
            userTransaction:0          
        };
        case types.USER_ERRORDETAILS: return{
            ...state,
            ErrorStatus: action.getResponse,
        }
        case types.USER_ERRORRESET: return{
            ...state,
            loggedIn: true,
            user_type: "property_manager",
        }
        case types.GET_USERROLE_PERMISSION: return{
            ...state,
            HasApplicationFullAcess: action.getResponse.hasAccess
        }
        case types.GET_WORKORDERROLE_PERMISSION: return{
            ...state,
            HasWorkOrderAccess: action.getResponse.hasAccess
        }
        case types.WORKORDER_PREFERENCE_SUCCESSSFULL: return{
            ...state,
            workorder_user_preferencedetails: action.workorder_user_preferencedetails
        }
        case types.WORKORDER_USER_PREFERENCE_SUCCESSFUL: return{
            ...state,
            workorder_user_preferencedetails: action.getResponse
        }
        case types.PREVENTATIVE_PREFERENCE_SUCCESSSFULL: return{
            ...state,
            preventative_maintenance_user_preferencedetails: action.preventative_maintenance_user_preferencedetails
        }
        case types.PREVENTATIVE_USER_PREFERENCE_SUCCESSFUL: return{
            ...state,
            preventative_maintenance_user_preferencedetails: action.getResponse
        }
        case types.ONPRIMISE_ERRORRESET: return{
            ...state,
            loggedIn: true,
            user_type: "property_manager",
            API_not_responding: false, 
        }
        default : return state; 
    }   
}
